'use strict';

(function() {

function authInterceptor($rootScope, $q, $cookies, $injector, Util, $location) {
  var state;
  return {
    // Add authorization token to headers
    request(config) {
      config.headers = config.headers || {};
      if ($cookies.get('token') && Util.isSameOrigin(config.url)) {
        config.headers.Authorization = 'Bearer ' + $cookies.get('token');
      }
      return config;
    },

    // Intercept 401s and redirect you to login
    responseError(response) {
      if (response.status === 401) {
        if(response.data.message!='This password is not correct.'){  
        // remove any stale tokens
        $cookies.remove('token');
        // localStorage.setItem('isAuthorised',false);
        (state || (state = $injector.get('$state'))).go('main', {isAuthorised:false});
      }
      }
      return $q.reject(response);
    }
  };
}

angular.module('pulianiBookStoreApp.auth')
  .factory('authInterceptor', authInterceptor);

})();
